import React from 'react';
import { HANDICAPTYPE } from "../../shared/constants/constants";

class HandicapTypeSelect extends React.Component {

  // plus besoin de bind dans le constructor
  handicapTypeChange = (event) => {
    const handicapType = event.target.value;
    this.props.handicapTypeChange(handicapType);
  };

  render() {
    return (
      <select
        className={"form-control " + this.props.specificClass}
        id="handicapType"
        value={this.props.handicapType}
        onChange={this.handicapTypeChange}
      >
        <option>{HANDICAPTYPE.NONE}</option>
        <option>{HANDICAPTYPE.TRS}</option>
        <option>{HANDICAPTYPE.SCAB}</option>
        <option>{HANDICAPTYPE.PARTIES}</option>
        <option>{HANDICAPTYPE.MOY}</option>
        <option>{HANDICAPTYPE.MOY500}</option>
      </select>
    );
  }
}

export default HandicapTypeSelect;
